module.exports = __webpack_public_path__ + "img/w3_circle_bars_light.f56ad15a.png";